module.exports = __webpack_public_path__ + "static/media/kennyonmushrooms.3109d32e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/kennyonmushrooms.jpg
// module id = 235
// module chunks = 0